export function dnqStates() {
  return [
    { name: 'Connecticut', abbreviation: 'CT' },
    { name: 'Oregon', abbreviation: 'OR' },
    { name: 'Vermont', abbreviation: 'VT' },
    { name: 'West Virginia', abbreviation: 'WV' },
    { name: 'Wisconsin', abbreviation: 'WI' },
  ]
}

export function getDNQStateByAbbreviation(abbreviation: string) {
  return dnqStates().find((state) => state.abbreviation === abbreviation)
}

export function getDNQStateByName(name: string) {
  return dnqStates().find((state) => state.name === name)
}

export function getDNQStateByAbbreviationOrName(value: string) {
  return getDNQStateByAbbreviation(value) || getDNQStateByName(value)
}
